import { RequireAutorization } from './routerAuth'
const RecipientIndex = () => import(/* webpackChunkName: "recipient" */ '@/components/recipient/Index.vue')
const RecipientShow = () => import(/* webpackChunkName: "recipient" */ '@/components/recipient/show/Index.vue')
const RecipientLayout = () => import(/* webpackChunkName: "recipient" */ '@/components/recipient/Layout.vue')
const RecipientList = () => import(/* webpackChunkName: "recipient" */ '@/components/recipient/List.vue')
const RecipientMultiples = () => import(/* webpackChunkName: "recipient" */ '@/components/recipient/multiples/Index.vue')
const RecipientMultiplesNew = () => import(/* webpackChunkName: "recipient" */ '@/components/recipient/multiples/New.vue')
const RecipientNew = () => import(/* webpackChunkName: "recipient" */ '@/components/recipient/New.vue')
const RecipientShowTimeline = () => import(/* webpackChunkName: "recipient" */ '@/components/recipient/show/Timeline.vue')
const RecipientShowInfo = () => import(/* webpackChunkName: "recipient" */ '@/components/recipient/show/Info.vue')

export const ROUTE_RECIPIENTS = [
  {
    path: '/destinatario',
    component: RecipientLayout,
    children: [
      {
        path: '',
        name: 'RecipientIndex',
        component: RecipientIndex,
        children: [
          {
            path: 'criar',
            name: 'RecipientNew',
            component: RecipientNew,
            meta: {
              title: 'Criar um novo destinatario'
            },
            beforeEnter: RequireAutorization
          }
        ],
        beforeEnter: RequireAutorization
      },
      {
        path: ':recipientId/',
        name: 'RecipientShow',
        component: RecipientShow,
        children: [
          {
            path: 'timeline',
            name: 'RecipientShowTimeline',
            components: {
              default: RecipientList,
              sidebar: RecipientShowTimeline
            },
            meta: {
              title: 'Acompanhe a timeline'
            },
            beforeEnter: RequireAutorization
          },
          {
            path: 'informacoes',
            name: 'RecipientShowInfo',
            components: {
              default: RecipientList,
              sidebar: RecipientShowInfo
            },
            meta: {
              title: 'Informações do Rementente'
            },
            beforeEnter: RequireAutorization
          }
        ]
      }
    ]
  },
  {
    path: 'importacoes-realizadas',
    name: 'RecipientMultiples',
    component: RecipientMultiples,
    children: [
      {
        path: 'criar',
        name: 'RecipientMultiplesNew',
        component: RecipientMultiplesNew,
        meta: {
          title: 'Importar destinatarios'
        },
        beforeEnter: RequireAutorization
      }
    ],
    beforeEnter: RequireAutorization
  }
]
